<template>
    <div class="flex relative justify-center pt-8">
        <div class="w-20 absolute left-0 flex items-center">
            <div class="whitespace-nowrap text-sm">Отображать по:</div>
            <dropdown v-model="itemsPerPage" theme="white" class="min-w-16 ds-pager-page-size" :options>{{ itemsPerPage.name }}</dropdown>
        </div>
        <vue-awesome-paginate
            v-if="items > itemsPerPage.id"
            :total-items="items"
            :items-per-page="itemsPerPage.id"
            :max-pages-shown="5"
            v-model="currentPage"
            @click="onClickHandler"
            :hide-prev-next="true"
        />
    </div>
</template>

<script setup lang="ts">
import { ref, watch } from 'vue'
const { items } = defineProps({
    items: {
        type: Number,
        required: true,
        default: 0
    }
})

const emit = defineEmits(['page', 'perpage'])

const options = [
    { id: 15, name: '15' },
    { id: 30, name: '30' }
    ]
const itemsPerPage = ref(options[0])
const currentPage = ref(1)


const onClickHandler = (page: number) => {
    emit('page', { page, itemsPerPage: itemsPerPage.value })
}

watch(itemsPerPage, () => {
    currentPage.value = 1
    onClickHandler(1)
})

watch(() => items, () => {
    currentPage.value = 1
})

</script>

<style>
    /* .active {
        background-color: #211A4D;
        color: #fff;
        border-radius: 4px;
    } */
    .pagination-container {
    display: flex;
    column-gap: 5px;
  }

  .paginate-buttons {
    height: 24px;
    width: 24px;
    border-radius: 4px;
    cursor: pointer;
    font-size: 14px;
  }

  .active-page {
    background: #211A4D;
    color: white;
  }

</style>
